var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-tool" },
    [
      _vm.isAdmin
        ? _c(
            "span",
            { staticClass: "span-blue-btn", on: { click: _vm.editCard } },
            [_vm._v("编辑")]
          )
        : _vm._e(),
      _vm.item.templateType !== "THIRD_SHEET"
        ? _c(
            "span",
            {
              staticClass: "span-blue-btn",
              on: { click: _vm.downloadCardAction },
            },
            [_vm._v("下载")]
          )
        : _vm._e(),
      _vm.isAdmin
        ? _c(
            "el-popover",
            {
              attrs: {
                width: "40px",
                trigger: "hover",
                "popper-class": "yj-popover-more",
              },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c("div", { staticClass: "yj-popover-actions" }, [
                !_vm.item.examId
                  ? _c(
                      "p",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openDialog("update")
                          },
                        },
                      },
                      [_vm._v("修改")]
                    )
                  : _vm._e(),
                _vm.isShowCopy
                  ? _c(
                      "p",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openDialog("copy")
                          },
                        },
                      },
                      [_vm._v("复制")]
                    )
                  : _vm._e(),
                _c(
                  "p",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.openDialog("delete")
                      },
                    },
                  },
                  [_vm._v("删除")]
                ),
              ]),
              _c(
                "p",
                {
                  staticClass: "exam-more",
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [
                  _c("span", { staticClass: "span-blue-btn more" }, [
                    _vm._v(" 更多"),
                    _c("i", {
                      class: "el-icon-arrow-" + (_vm.visible ? "up" : "down"),
                    }),
                  ]),
                ]
              ),
            ]
          )
        : [
            _vm.isShowCopy
              ? _c(
                  "span",
                  {
                    staticClass: "span-blue-btn more",
                    on: {
                      click: function ($event) {
                        return _vm.openDialog("copy")
                      },
                    },
                  },
                  [_vm._v("复制")]
                )
              : _vm._e(),
          ],
      _c(
        "yue-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialog.visible,
            width: "500px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-body" },
            [
              _vm.dialog.type === "delete"
                ? _c("p", { staticClass: "dialog-body-content" }, [
                    _vm.item.creatorId == _vm.userInfo.userId
                      ? _c("span", [
                          _vm._v("答题卡模板删除后不可恢复，是否确认删除？"),
                        ])
                      : _c("span", [
                          _vm._v(
                            "当前答题卡模板并非本人创建，删除后不可恢复,是否确认删除？"
                          ),
                        ]),
                  ])
                : _vm.dialog.type === "download"
                ? _c("p", { staticClass: "dialog-body-content" }, [
                    _c("span", [
                      _vm._v(
                        "该答题卡已下载，不可编辑，是否复制为新卡进行编辑？"
                      ),
                    ]),
                  ])
                : _c(
                    "el-form",
                    {
                      staticClass: "print-form",
                      attrs: { "label-width": "82px", size: "small" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "模板名称：", required: "" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.item.templateName + "模板",
                            },
                            model: {
                              value: _vm.form.templateName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "templateName", $$v)
                              },
                              expression: "form.templateName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.dialog.type === "update"
                        ? [
                            _c(
                              "el-form-item",
                              {
                                key: _vm.item.id,
                                attrs: { label: "所属年级：", required: "" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: "请选择年级" },
                                    model: {
                                      value: _vm.form.grade,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "grade", $$v)
                                      },
                                      expression: "form.grade",
                                    },
                                  },
                                  _vm._l(
                                    _vm.xGradeList,
                                    function (grade, index) {
                                      return _c("el-option", {
                                        key: "grade" + index,
                                        attrs: {
                                          label: grade.gradeName,
                                          value: grade.gradeNum,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
              _c(
                "p",
                { staticClass: "dialog-body-footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.dialog.okAction },
                    },
                    [_vm._v("确定")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", plain: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog.visible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }